import { Grid, MenuItem, TextField, Typography, InputLabel } from '@material-ui/core';
import type { StyledComponentProps } from '@material-ui/core/styles';
import { constants } from 'helpers/constants';
import { EChargeType } from 'interfaces/IEditProduct';
import { EPartnerCode } from 'interfaces/IProduct';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import eduzzAccountsService from 'v2/services/eduzzAccount';

import type { User } from 'v2/interfaces/user';

import BlockedFieldTooltipProps from './../General/blockedTooltipProps';
import { Offers } from './components/Offers';
import { TaxAlert } from './components/Offers/TaxAlert';
import SinglePayment from './components/SinglePayment';
import Subscription from './components/Subscription';
import { FormContent } from '../FormContent';
import styles from '../styles';

import type IProduct from 'interfaces/IProduct';
import type { DispatchProp } from 'react-redux';

interface IProps extends IPropsFromConnect, DispatchProp<any>, StyledComponentProps {
  loading: boolean;
  fade?: any;
  product?: IProduct;
  modifieds?: any[];
  editing?: any;
  handleChange?: any;
  copyFromOriginal?: any;
  currencyList: any;
  onChangeRequiredFields?: any;
  classes?: any;
  openConfirmModal: () => void;
}

interface IPropsFromConnect {
  currentUser: User;
}

interface IStates {
  showErrors: boolean;
  validationErrors: any;
  singlePaymentErrors: any;
  subscriptionErrors: any;
  userHasAccessToSubscriptionModule: boolean;
}

class Sale extends Component<IProps, IStates> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      showErrors: false,
      validationErrors: [],
      singlePaymentErrors: {},
      subscriptionErrors: {},
      userHasAccessToSubscriptionModule: false,
    };
  }
  errorFor = (field: any) => {
    return this.state.validationErrors[field] || '';
  };

  isValid = (field: any) => {
    return this.state.validationErrors[field] ? true : false;
  };
  onChangeRequired = (name: string, fields: any) => {
    let newState = this.state;
    newState[name] = fields;
    this.setState(newState);
  };

  onChangeStates = () => {
    let { product, onChangeRequiredFields } = this.props;
    const { singlePaymentErrors, subscriptionErrors } = this.state;
    let newValidations = this.state.validationErrors;
    if (product.charge_type === EChargeType.SINGLE) {
      newValidations = { ...singlePaymentErrors };
    } else if (product.charge_type === EChargeType.SUBSCRIPTION) {
      newValidations = { ...subscriptionErrors };
    }
    this.setState({ validationErrors: newValidations });
    if (onChangeRequiredFields) {
      onChangeRequiredFields('salesRequiredFields', newValidations ? Object.keys(newValidations).length : 0);
    }
  };

  componentDidUpdate(prevProps: IProps) {
    if (!this.props.loading && this.props.product !== prevProps.product) {
      this.onChangeStates();
    }
  }

  componentDidMount() {
    let getSubscriptionBetaModuleStatus = eduzzAccountsService.verifyUserHasBetaModule('planos_assinatura');

    this.setState({ userHasAccessToSubscriptionModule: getSubscriptionBetaModuleStatus });

    if (!this.props.loading) {
      this.onChangeStates();
    }
  }
  render() {
    const { loading, handleChange, product, modifieds, editing, currencyList, classes, currentUser } = this.props;
    const { userHasAccessToSubscriptionModule } = this.state;

    const isAlumy = product.cnt_partner_cod === EPartnerCode.ALUMY;
    const isBlinket = product.cnt_partner_cod === EPartnerCode.BLINKET;
    const currencies = Array.isArray(currencyList) ? currencyList : [];
    const isSinglePayment = product.charge_type === EChargeType.SINGLE;
    const isSubscription = product.charge_type === EChargeType.SUBSCRIPTION;
    const isInfo = product.type === constants.INFO;
    const hasOffersAccess = isSinglePayment && isInfo;
    const isCreatingNewVariation = product.isVariation() && !product.id;
    const showCurrencyLabel = (isCreatingNewVariation || !isInfo) && (isSinglePayment || isSubscription);
    const hasUnsavedChanges = Object.keys(modifieds).length > 0;

    const disableChageType = userHasAccessToSubscriptionModule && isSubscription;

    const allowRecurrency =
      product.type === constants.INFO ||
      product.type === constants.SERVICE ||
      (product.type === constants.PHYSICAL && currentUser.subscription_physical);

    return (
      <Grid container spacing={2} alignItems='center'>
        <Grid item xs={12}>
          <FormContent title='Formas de cobrança' loading={loading}>
            <Grid container spacing={2} alignItems='center'>
              <Grid item xs={12}>
                <BlockedFieldTooltipProps
                  partnerCod={product.cnt_partner_cod}
                  enabled={isAlumy || isBlinket}
                  title={isAlumy ? 'Produto do tipo Alumy não pode ser alterado o tipo de cobrança' : null}
                >
                  <TextField
                    id='charge_type'
                    select
                    fullWidth
                    value={product.charge_type}
                    onChange={(e: any) => {
                      if (e.target.value === EChargeType.OTHER) {
                        handleChange('recovery_email', '');
                        handleChange('sales_recovery', false);
                        handleChange('recruit_commission_type', 'P');
                        handleChange('comission_type', 'P');
                      }

                      if (e.target.value !== EChargeType.SUBSCRIPTION) {
                        handleChange('trial', false);
                      }

                      if (e.target.value !== EChargeType.SUBSCRIPTION && e.target.value !== EChargeType.FREE && product.allows_card) {
                        handleChange('allows_multiple_cards', true);
                      }

                      if (e.target.value !== EChargeType.SINGLE) {
                        handleChange('interest_free_installment', false);
                      }

                      if (e.target.value === 'A') {
                        handleChange('recurring_frequency', 1);
                      }

                      handleChange('charge_type', e.target.value);
                    }}
                    label='Tipo de cobrança'
                    InputProps={{
                      disableUnderline: true,
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    disabled={isAlumy || isBlinket || disableChageType}
                  >
                    <MenuItem value={EChargeType.SINGLE}>Única</MenuItem>
                    {allowRecurrency && !userHasAccessToSubscriptionModule && (
                      <MenuItem value={EChargeType.SUBSCRIPTION}>Assinatura/Recorrência</MenuItem>
                    )}
                    {(product.type === constants.INFO || product.type === constants.SERVICE) && (
                      <MenuItem value={EChargeType.OTHER}>Valor Aberto</MenuItem>
                    )}
                    {product.type !== 3 && <MenuItem value={EChargeType.FREE}>Gratuito</MenuItem>}
                  </TextField>
                </BlockedFieldTooltipProps>
              </Grid>

              {showCurrencyLabel && (
                <Grid item xs={12} sm='auto' style={{ alignSelf: 'baseline' }}>
                  <div className={classes.brlCurrencyContainer}>
                    <InputLabel>Moeda</InputLabel>
                    <Typography variant='body1'>BRL (Real Brasileiro)</Typography>
                  </div>
                </Grid>
              )}

              {product.charge_type === EChargeType.SINGLE && (
                <SinglePayment
                  product={product}
                  handleChange={handleChange}
                  onChangeRequiredFields={this.onChangeRequired}
                  loading={loading}
                  currencies={currencies}
                />
              )}
              {product.charge_type === EChargeType.SUBSCRIPTION && (
                <Subscription
                  product={product}
                  handleChange={handleChange}
                  onChangeRequiredFields={this.onChangeRequired}
                  modifieds={modifieds}
                  editing={editing}
                  loading={loading}
                  isAlumy={isAlumy}
                  currencies={currencies}
                />
              )}
              {product.charge_type === EChargeType.OTHER && (
                <Grid item xs={12}>
                  <p>
                    O valor <strong>minímo</strong> no checkout será de R$ 5,00
                  </p>
                  <p>Não será habilitado o parcelamento no checkout</p>
                </Grid>
              )}
              {product.charge_type === EChargeType.FREE && (
                <>
                  <Grid item xs={12} md={2}>
                    <div>
                      <img src='/img/eduzzinho-thumbsup.png' alt='Eduzzinho' width='100px' style={{ marginRight: '50px' }} />
                    </div>
                  </Grid>
                  <Grid item xs={12} md={10}>
                    <b>Eba! Produto gratuito.</b>
                    <p>Produto gratuito é uma ótima maneira de captar leads, você pode utilizar como produto de entrada para outro produto pago.</p>
                  </Grid>
                </>
              )}
            </Grid>
          </FormContent>
        </Grid>
        {hasOffersAccess && !isCreatingNewVariation && (
          <>
            <Grid item xs={12}>
              <Offers product={product} loading={loading} hasUnsavedChanges={hasUnsavedChanges} openConfirmModal={this.props.openConfirmModal} />
            </Grid>
            <Grid item xs={12}>
              <TaxAlert />
            </Grid>
          </>
        )}
      </Grid>
    );
  }
}
function mapStateToProps(state: any) {
  return {
    currentUser: state.orbita.User.user.user,
  };
}

export default connect(mapStateToProps)(styles(Sale));
